module.exports = __webpack_public_path__ + "media/club_product_v2/6-42ab2db8.webp";